import React, { useState } from "react";
import "./Projects.css";
import "./Portfolio.css";
import OceanView1 from "../images/oceanView1.jpg";
import OceanView2 from "../images/oceanView2.jpg";
import axios from "axios";

// import PrevNextBtns from './PrevNextBtns';
import { useNavigate } from "react-router-dom";

const Projects = () => {
  interface onSubmit {
    body: string;
    title: string;
  }
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [posts, setPost] = useState([]);
  console.log("title:", title);
  console.log("body:", body);
  console.log("posts:", posts);

  const submit = (e: React.FormEvent<HTMLFormElement> & onSubmit) => {
    e.preventDefault();
    const payload = {
      title: e.title,
      body: e.body,
    };

    //get from database

    const getBlogPost = () => {
      axios
        .get("/api")
        .then((response) => {
          const data = response.data;
          setPost(data);
          console.log("Data has been recieved:" + data);
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    };
    //Client to server post request-->
    axios({
      url: "/api/save",
      method: "POST",
      data: payload,
    })
      .then(() => {
        console.log("Data has been sent to server!");
        setTitle("");
        setBody("");
        getBlogPost();
      })
      .catch(() => {
        console.log("error found");
      });
  };

  const navigate = useNavigate();
  function handleClick() {
    navigate("/Contact");
  }
  function backClick() {
    navigate("/About");
  }
  return (
    <>
      <div className="project-bg-wrapper">
        <h1>Projects</h1>

        <div className="project-wrapper">
          <div className="row">
            <div className="column">
              <h2>Single-Page Web Design</h2>
              <div className="i-anchor1">
                <a
                  href="https://ineso1984.github.io/WebDesign1/"
                  target="_blank"
                  rel="noreferrer"
                >
                  View Design
                </a>
              </div>

              <img src={OceanView1} alt="screenshot" className="i-proj1 img1" />
              <img src={OceanView2} alt="screenshot" className="i-proj1 img2" />
            </div>
            <div className="column">
              <h2>Welcome to my Blog</h2>
              <p>Project created using MongoDB</p>

              <div>
                <form onSubmit={submit}>
                  <div className="form-input">
                    <input
                      type="text"
                      name="title"
                      placeholder="Title"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </div>
                  <div className="form-input">
                    <textarea
                      name="body"
                      placeholder="body"
                      cols={30}
                      rows={10}
                      value={body}
                      onChange={(e) => setBody(e.target.value)}
                    ></textarea>
                  </div>
                  <button>Submit</button>
                </form>
              </div>
            </div>

            <div className="column">Project 3</div>
          </div>
          <div className="container">
            <button className="btn btn-gr projects" onClick={backClick}>
              Back
            </button>
            <button className="btn btn-gr projects" onClick={handleClick}>
              Next
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Projects;
